import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Table } from "@/components/ui/Table";
import { Title } from "@/components/ui/Title.ts";
import { Breadcrumbs } from "@/components/ui/Breadcrumbs.ts";
import { IoChevronForward } from "react-icons/io5";
import { dataApi } from "@/api/data";
import { StepOperator } from "@/types/assistants.ts";
import { OperatorBadge } from "@/pages/assistants/ScenarioStepsPage/styles.ts";
import {useAppDispatch, useAppSelector} from "@/hooks/redux.ts";
import {fetchAssistant} from "@/store/assistantSlice.ts";

const TableHeaders = [
    { text: 'Тип', value: 'type', width: '120px' },
    { text: 'Имя', value: 'name' },
    { text: 'Ссылка на сценарий', value: 'scenario' },
]

interface ITableDataItem {
    type: string,
    name: string
    scenario: string,
    id: number
}

export const FilesAndData = () => {
    const [data, setData] = useState<ITableDataItem[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { id } = useParams();
    const dispatch = useAppDispatch();
    const { assistant } = useAppSelector(state => state.assistant);

    useEffect(() => {
        if(id) {
            setIsLoading(true);
            dispatch(fetchAssistant(Number(id)))
            dataApi.getAll(id)
                .then(({ data }) => {
                    const mappedData = data.map(i => ({
                        type: i.Operator,
                        name: i.Name,
                        scenario: (i.S?.Name || '') + ` (Шаг ${i.Step})`,
                        id: i.ID
                    }))
                    setData(mappedData)
                })
                .finally(() => {
                setIsLoading(false)
            })
        }
    }, [id]);

    return (
        <div>
            <Title>Файлы и данные</Title>
            <Breadcrumbs style={{ marginTop: '24px' }}>
                <Link to="/dashboard/assistants">Мои ассистенты</Link>
                <IoChevronForward size={14} color="#000000"/>
                <Link to={`/dashboard/assistants/${assistant?.ID}/scenarios`}>{assistant?.Name}</Link>
                <IoChevronForward size={14} color="#000000"/>
                <span>Файлы и данные</span>
            </Breadcrumbs>
            <Table headers={TableHeaders} loading={isLoading} data={data} tableKey={'id'}>
                {({value, column, item}) => {
                    if(column === 'type') {
                        return (
                            <div style={{ height: '42px', display: 'flex', alignItems: 'center' }}>
                                <OperatorBadge
                                    operator={value as StepOperator}
                                    style={{cursor: 'pointer'}}
                                    className="operator-badge"
                                >
                                    {value}
                                </OperatorBadge>
                            </div>
                        )
                    }
                    if(column === 'name') {
                        return (
                            <div style={{ height: '42px', display: 'flex', alignItems: 'center' }}>
                                <Link to={`/dashboard/assistants/${id}/data/${item.id}`}>{value || 'Нет данных'}</Link>
                            </div>
                        )
                    }
                    return (
                        <div style={{ height: '42px', display: 'flex', alignItems: 'center' }}>
                            { value }
                        </div>
                    )
                }}
            </Table>
        </div>
    )
}
